import { SelectProps } from "antd";
import { AreaComumDia } from "core/features/area-comum/enums";
import { useMemo } from "react";
import SelectBaseAntd from "../SelectBaseAntd";

const items: { label: string; value: AreaComumDia }[] = [
  {
    label: "Segunda-feira",
    value: AreaComumDia.Segunda,
  },
  {
    label: "Terça-feira",
    value: AreaComumDia.Terca,
  },
  {
    label: "Quarta-feira",
    value: AreaComumDia.Quarta,
  },

  {
    label: "Quinta-feira",
    value: AreaComumDia.Quinta,
  },
  {
    label: "Sexta-feira",
    value: AreaComumDia.Sexta,
  },
  {
    label: "Sábado",
    value: AreaComumDia.Sabado,
  },
  {
    label: "Domingo",
    value: AreaComumDia.Domingo,
  },
  {
    label: "No Feriado",
    value: AreaComumDia.Feriado,
  },
  {
    label: "1 dia antes do feriado",
    value: AreaComumDia.DiaAntesFeriado,
  },
  {
    label: "1 dia depois do feriado",
    value: AreaComumDia.DiaDepoisFeriado,
  },
];

export interface SelectPeriodoDiasProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  excludeItems?: AreaComumDia[];
  onChange: (v: any) => void;
}

function SelectPeriodoDias({
  value,
  isInvalid,
  excludeItems,
  onChange,
  ...rest
}: SelectPeriodoDiasProps) {
  const data = useMemo(() => {
    if (excludeItems?.length) {
      return items.filter((item) => {
        const exists = excludeItems.find((v) => v === item.value);

        if (exists) {
          return false;
        }

        return true;
      });
    }

    return items;
  }, [excludeItems]);

  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        value={value}
        showSearch={false}
        allowClear={false}
        options={data}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      />
    </>
  );
}

export default SelectPeriodoDias;
